export const SALEORDER_SIGNED_CONTRACT = "SIGNED_CONTRACT";
export const SALEORDER_PAYABLE = "PAYABLE";
export const SALEORDER_WITH_PAYMENTS = "WITH_PAYMENTS";



// WEBPACK FOOTER //
// ./src/constants/saleOrderTypeConst.js